import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { stepIdxSelector } from 'redux/stepSlice';

import ProvideSampleDataStep from 'components/ProvideSampleDataStep';
import ConfirmSchemaStep from 'components/ConfirmSchemaStep';
import IdentifyKeyFieldsStep from 'components/IdentifyKeyFieldsStep';
import ViewMetricsStep from 'components/ViewMetricsStep';

import {
  StyledStepperContainer,
  StyledStepper,
  StyledStepContentContainer,
  StyledStepperItem
} from './MetricsWizard-styled';

const MetricsWizard: React.FC = () => {
  const stepIdx = useSelector(stepIdxSelector);

  const stepContent = useMemo(() => {
    switch (stepIdx) {
      case 0:
        return <ProvideSampleDataStep></ProvideSampleDataStep>;
      case 1:
        return <ConfirmSchemaStep></ConfirmSchemaStep>;
      case 2:
        return <IdentifyKeyFieldsStep></IdentifyKeyFieldsStep>;
      case 3:
        return <ViewMetricsStep></ViewMetricsStep>;
      default:
        return <ProvideSampleDataStep></ProvideSampleDataStep>;
    }
  }, [stepIdx]);

  return (
    <StyledStepperContainer>
      <StyledStepper numbered>
        <StyledStepperItem
          key="provideSampleData"
          description="Paste a sample of the incoming data"
          disabled
          selected={stepIdx === 0}
          title="Provide Sample Data"
        />
        <StyledStepperItem
          key="confirmSchema"
          description="Confirm Schema"
          disabled
          selected={stepIdx === 1}
          title="Build the schema"
        />
        <StyledStepperItem
          key="identifyKeyFields"
          description="Identify Key Fields"
          disabled
          selected={stepIdx === 2}
          title="Specify fields for spatial and temporal capabilities"
        />
        <StyledStepperItem
          key="viewMetrics"
          description="View Metrics"
          disabled
          selected={stepIdx === 3}
          title="View the calculated metrics"
        />
      </StyledStepper>
      <StyledStepContentContainer>{stepContent}</StyledStepContentContainer>
    </StyledStepperContainer>
  );
};

export default MetricsWizard;
